import * as yup from 'yup';

export const formatBirthdateInput = (value = '') => {
  const digits = value.replace(/\D/g, '').slice(0, 8);

  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const isValidBirthdate = (mmddyyyy) => {
  if (!mmddyyyy || !/^(?:\d{2}\/){2}\d{4}$/.test(mmddyyyy)) return false;

  const [month, day, year] = mmddyyyy.split('/').map(Number);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

export const formatBirthdateForApi = (mmddyyyy) => {
  const [month, day, year] = mmddyyyy.split('/');
  return `${month}-${day}-${year}`;
};

export const createVerifyBirthdateValidationSchema = ({
  requiredMessage,
  invalidMessage,
}) => yup.object({
  birthdate: yup
    .string()
    .required(requiredMessage)
    .test(
      'is-valid-birthdate',
      invalidMessage,
      (value) => !value || isValidBirthdate(value),
    ),
});